import React, { useState } from 'react';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
export function AdminLogin() {
  const {
    adminLogin
  } = useAdminAuth();
  const [email, setEmail] = useState('admin@showpilot.com');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    setIsLoading(true);
    try {
      const success = await adminLogin(email, password);
      if (!success) {
        setError('Invalid credentials. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4 admin-portal" data-id="element-37">
      <div className="w-full max-w-md" data-id="element-38">
        {/* Logo/Branding */}
        <div className="text-center mb-8" data-id="element-39">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-xl mb-4" data-id="element-40">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-41">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-42" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-43">Admin Portal</h1>
          <p className="text-gray-400" data-id="element-44">Sign in to access the admin dashboard</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8" data-id="element-45">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-46">
            {error && <div className="bg-red-50 border border-red-200 rounded-lg p-3" data-id="element-47">
                <p className="text-sm text-red-800" data-id="element-48">{error}</p>
              </div>}

            <div data-id="element-49">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-50">
                Email Address
              </label>
              <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@example.com" disabled={isLoading} className="w-full" data-id="element-51" />
            </div>

            <div data-id="element-52">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-53">
                Password
              </label>
              <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" disabled={isLoading} className="w-full" data-id="element-54" />
            </div>

            <Button type="submit" disabled={isLoading} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition-colors" data-id="element-55">
              {isLoading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

          <div className="mt-6 text-center" data-id="element-56">
            <p className="text-sm text-gray-500" data-id="element-57">
              For security purposes, admin accounts are managed separately.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8" data-id="element-58">
          <p className="text-sm text-gray-500" data-id="element-59">
            © 2025 Dubai Active. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}